import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b745f68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "x-modal x-modal__settings"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "x-modal__container h-stack" }
const _hoisted_4 = { class: "x-modal__header v-stack" }
const _hoisted_5 = { class: "tabs-header" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "x-modal__content" }
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = { class: "tab-content__title sticky-title" }
const _hoisted_10 = { class: "tab-content__viewer" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

import { ref, computed } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import TransmissionSetting from './transmission.vue'
import ServiceSetting from './service.vue'
import VersionController from './version.vue'
import HeziClient from './hezi-client.vue'
import HardwareSettings from './hardware-settings.vue'
import { E_SETTING_TAB } from './helper'
import {isHeziPCClient} from '@remote/utils/hezi-pc-client'

interface ISettingTab {
  key: E_SETTING_TAB
  label: string
}

interface IProps {
  defaultActiveKey?: E_SETTING_TAB
  mask?: boolean
  closeOnMaskClick?: boolean
}
interface IEmits {
  (e: 'dialog-close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    defaultActiveKey: { default: 'transmission' as E_SETTING_TAB },
    mask: { type: Boolean, default: false },
    closeOnMaskClick: { type: Boolean, default: false }
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { defaultActiveKey: E_SETTING_TAB, mask: boolean, closeOnMaskClick: boolean }





// const isMountedRef = ref(false)
// const isEditing = ref(false)
const tabs: ISettingTab[] = [
  { key: E_SETTING_TAB.transmission, label: '传输设置' },
  { key: E_SETTING_TAB.service, label: '服务设置' },
  { key: E_SETTING_TAB.hardwaresettings, label: '硬件设置' },
  { key: E_SETTING_TAB.version, label: '服务版本更新' },
  { key: E_SETTING_TAB.heziclient, label: '关于迅雷盒子' },
]

if (!isHeziPCClient()) tabs.pop()

const activeTab = ref<E_SETTING_TAB>(props.defaultActiveKey)
const mountedRef = ref(true)
const current = computed(() => {
  const tab = tabs.find(t => t.key === activeTab.value)
  return tab!
})

const { close } = usePromisifyDialog(emit)
function onClose () {
  mountedRef.value = false
  close(null)
}

function onMaskClick () {
  if (!props.closeOnMaskClick) return
  onClose()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (mountedRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.mask)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "x-modal__mask",
                onClick: _withModifiers(onMaskClick, ["self"])
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("aside", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                  return _createElementVNode("div", {
                    key: tab.key,
                    class: _normalizeClass(["tab-item", { 'is-current': activeTab.value === tab.key }]),
                    onClick: ($event: any) => (activeTab.value = tab.key)
                  }, [
                    _createElementVNode("h2", null, _toDisplayString(tab.label), 1)
                  ], 10, _hoisted_6)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(current).label), 1),
                    _createElementVNode("section", _hoisted_10, [
                      _withDirectives(_createVNode(TransmissionSetting, null, null, 512), [
                        [_vShow, activeTab.value === _unref(E_SETTING_TAB).transmission]
                      ]),
                      _withDirectives(_createVNode(ServiceSetting, null, null, 512), [
                        [_vShow, activeTab.value === _unref(E_SETTING_TAB).service]
                      ]),
                      _withDirectives(_createVNode(VersionController, null, null, 512), [
                        [_vShow, activeTab.value === _unref(E_SETTING_TAB).version]
                      ]),
                      _withDirectives(_createVNode(HeziClient, null, null, 512), [
                        [_vShow, activeTab.value === _unref(E_SETTING_TAB).heziclient]
                      ]),
                      _withDirectives(_createVNode(HardwareSettings, {
                        "is-active": activeTab.value === _unref(E_SETTING_TAB).hardwaresettings
                      }, null, 8, ["is-active"]), [
                        [_vShow, activeTab.value === _unref(E_SETTING_TAB).hardwaresettings]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              class: "x-modal__close",
              onClick: onClose
            }, _hoisted_12)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})